




import { Vue, Component, Watch } from 'vue-property-decorator';
import { getDefaultAccountOptions } from '@/components/helper'
import AccountOptions from '@/models/AccountOptions'
import { Getter, Mutation } from 'vuex-class'
import { RootStateMutations } from '@/store/mutations'
import Account from '@/api/models/Account'
import AccountService from '@/api/services/AccountService'
import AccountOption from '@/api/models/AccountOption'
import ReferenceService from '@/api/services/ReferenceService';
import { ProductProperty } from '@/models/ProductProperty';

@Component
export default class AccountOptionsMixin extends Vue {
    $refs: {
        error: Element;
    }

    protected accountService = new AccountService()
    protected refService = new ReferenceService()
    protected accountOptions: AccountOptions = getDefaultAccountOptions()
    protected productProperties: Array<ProductProperty> = []
    protected error = ''

    @Mutation(RootStateMutations.setLoading)
    protected setLoading: (state: boolean) => void

    @Getter('currentAccount')
    protected currentAccount: Account

    @Watch('currentAccount')
    changeCurrentAccount() {
        this.loadData()
    }

    public async created (): Promise<void> {
        await this.loadData()
    }

    protected async loadData(): Promise<void> {
        this.setLoading(true)
        try {
            if (this.currentAccount?.id) {
                this.accountOptions = await this.accountService.getAccountOptions(this.currentAccount.id)
                this.productProperties = await this.refService.getProductProperties(this.currentAccount.id)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.internal.getAccountOptionsError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async updateAccountOptions(accountOption: AccountOption): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await this.accountService.updateAccountOptions(this.currentAccount.id, accountOption)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.internal.error').toString()

            this.scroll()
        } finally {
            this.setLoading(false)
        }
    }

    protected scroll (): void {
        this.$refs.error.scrollIntoView({ behavior: 'smooth' })
    }

    clearError(): void {
        this.error = ''
    }
}
